import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { Textarea } from '../../components';

interface Props {
  name: string;
  label?: ReactNode;
  placeholder?: string;
}

export default function TextareaField({ name, ...bag }: Props) {
  return (
    <Field name={name}>
      {({ field, form: { errors } }: FieldProps) => (
        <div>
          <Textarea rows={4} error={getIn(errors, name)} {...field} {...bag} />
        </div>
      )}
    </Field>
  );
}
